import { render, staticRenderFns } from "./DictionarySheet.vue?vue&type=template&id=ba30d292"
import script from "./DictionarySheet.vue?vue&type=script&lang=js"
export * from "./DictionarySheet.vue?vue&type=script&lang=js"
import style0 from "./DictionarySheet.vue?vue&type=style&index=0&id=ba30d292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports